import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "theme-container"
}
const _hoisted_2 = { class: "theme-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theme_display = _resolveComponent("theme-display")!

  return (_ctx.root !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.root.theme.title), 1),
        (_ctx.root.children.length > 0)
          ? (_openBlock(), _createBlock(_component_theme_display, {
              key: 0,
              themes: _ctx.themes,
              nodes: _ctx.root.children,
              "parent-id": _ctx.root.parentId,
              "entity-themes": _ctx.entityThemes
            }, null, 8, ["themes", "nodes", "parent-id", "entity-themes"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}